export default function ContactInformation() {
  return null;
}